import { GroupItemBaseTriggerItemsQualifier } from "./group-item-base-trigger-items";
export class FirstMatchGroupItemTriggerItemsQualifier extends GroupItemBaseTriggerItemsQualifier {
    _accepts;
    /**
     * @param sourceData  Menu/settings data the qualifier prices and matches against.
     * @param accepts     Optional veto over a matched row. Bug 75837: a Fixed Price coupon lists
     *                    several qualifying items and some of them can cost less than its price
     *                    point.
     */
    constructor(sourceData, accepts) {
        super(sourceData);
        this._accepts = accepts;
    }
    _qualifyCouponItemsGroupQTY(group, coupon, cart, couponGroupItems) {
        const triggerItems = [];
        for (const cItem of couponGroupItems) {
            const found = [];
            while (found.length < cItem.quantity) {
                const tItem = this._qualifyCouponItemsGroup(group, coupon, cart, cItem);
                if (!tItem)
                    break;
                found.push(tItem);
            }
            if (found.length === cItem.quantity) {
                if (this._accepts && !this._accepts(found, cart)) {
                    // Not a candidate the coupon can use: give the marked quantities back so the
                    // next row (and any later coupon) still sees the items as available.
                    this._releaseTriggerItems(found);
                    continue;
                }
                triggerItems.push(...found);
            }
            if (triggerItems.length > 0)
                break; // stop after first qualified
        }
        return triggerItems;
    }
}
//# sourceMappingURL=first-match-group-item-trigger-items.js.map